import { IChainTokenStat } from 'app-lib/apis/bzxApi'
import { autoFormat, formatPercent } from 'app-lib/numberUtils'
import React from 'react'
import TokenTip from 'shared-components/TokenTip'
import { Icon } from 'ui-framework'

export default function ReserveMobileItem({ statsItem }: { statsItem: IChainTokenStat }) {
  return (
    <div className="margin-bottom-1 panel--simple padded-1">
      <div className="title-section">
        <div className="flex-row-center">
          <Icon name={statsItem.logo} className="margin-right-05" />
          <TokenTip
            iTokenAddress={statsItem.iTokenAddress}
            iTokenExplorerUrl={statsItem.iTokenExplorerUrl}>
            <b>{statsItem.tokenName}</b>
          </TokenTip>
        </div>
      </div>
      <div className="reserve__item-grid">
        <div>
          <h4 className="txt-subtitle margin-right-1">TVL (USD)</h4>
          <div title={statsItem.usdTotalLocked ? `$${statsItem.usdTotalLocked}` : ``}>
            {statsItem.usdTotalLocked ? (
              <>
                <span className="txt-subtitle">$</span>
                <b>{autoFormat(statsItem.usdTotalLocked, 5)}</b>
              </>
            ) : (
              `-`
            )}
          </div>
        </div>
        <div>
          <h4 className="txt-subtitle">Total Supply</h4>
          <div>
            <div title={statsItem.totalSupply ? statsItem.totalSupply : ``}>
              {statsItem.totalSupply ? (
                <>
                  <b>{autoFormat(statsItem.totalSupply, 5)}</b>{' '}
                  <span className="txt-subtitle">{statsItem.tokenName}</span>
                </>
              ) : (
                `-`
              )}
            </div>
            <div title={statsItem.usdSupply ? statsItem.usdSupply : ``}>
              {statsItem.usdSupply ? (
                <>
                  <b>{autoFormat(statsItem.usdSupply, 5)}</b>
                  <span className="txt-subtitle">$</span>
                </>
              ) : (
                `-`
              )}
            </div>
          </div>
        </div>

        <div>
          <h4 className="txt-subtitle">Liquidity</h4>
          <div>
            <div title={statsItem.availableLiquidity ? statsItem.availableLiquidity : ``}>
              {statsItem.availableLiquidity ? (
                <>
                  <b>{autoFormat(statsItem.availableLiquidity, 5)}</b>{' '}
                  <span className="txt-subtitle">available</span>
                </>
              ) : (
                `-`
              )}
            </div>
            <div title={statsItem.totalBorrow ? statsItem.totalBorrow : ``}>
              {statsItem.totalBorrow ? (
                <>
                  <b>{autoFormat(statsItem.totalBorrow, 5)}</b>{' '}
                  <span className="txt-subtitle">borrowed</span>
                </>
              ) : (
                `-`
              )}
            </div>
          </div>
        </div>

        <div>
          <h4 className="txt-subtitle">Locked as Collateral</h4>
          <div title={statsItem.vaultBalance ? statsItem.vaultBalance : ``}>
            {statsItem.vaultBalance ? (
              <>
                <b>{autoFormat(statsItem.vaultBalance, 5)}</b>{' '}
                <span className="txt-subtitle">{statsItem.tokenName}</span>
              </>
            ) : (
              `-`
            )}
          </div>
        </div>

        <div>
          <h4 className="txt-subtitle">Lending Rate</h4>
          <div title={statsItem.supplyApr ? `${statsItem.supplyApr}%` : ``}>
            {statsItem.supplyApr ? (
              <>
                <b>{formatPercent(statsItem.supplyApr)}</b>
                <span className="txt-subtitle">%</span>
              </>
            ) : (
              `-`
            )}
          </div>
        </div>

        <div>
          <h4 className="txt-subtitle">Borrowing Rate</h4>
          <div title={statsItem.borrowApr ? `${statsItem.borrowApr}%` : ``}>
            {statsItem.borrowApr ? (
              <>
                <b>{formatPercent(statsItem.borrowApr)}</b>
                <span className="txt-subtitle">%</span>
              </>
            ) : (
              `-`
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
